module.exports = __webpack_public_path__ + "img/SERVICE.44852f8e.svg";